import { useContext, useEffect, useState } from "react";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import { APICall } from "../../Helpers/Network/APICalls";
import { GetMemberDashboardDetails } from "../../Helpers/APIEndPoints/EndPoints";
import Table from "react-bootstrap/Table";
//import "bootstrap/dist/css/bootstrap.min.css";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { Navigate, useNavigate } from "react-router-dom";
const SuretyDetails = (props) => {
  // const [suretyDetails, setSuretyDetails] = useState([]);
  const context = getContext();
  let MemberId = context.MemberId;
  const { showLoader, hideLoader } = useContext(LoaderContext);
  let navigate = useNavigate();
  const { suretyDetails } = props;

  // useEffect(() => {
  //   if (MemberId) {
  //     getDashboardData();
  //   }
  // }, []);

  // const getDashboardData = async () => {
  //   showLoader();
  //   let obj = {
  //     MemberId: MemberId,
  //   };
  //   const resp = await APICall(GetMemberDashboardDetails, obj);

  //   if (resp?.Data?.MemberSuretyDetailsList?.length > 0) {
  //     const extractedDetails = resp?.Data?.MemberSuretyDetailsList?.map(
  //       ({ MemberNo, MemberName }) => ({ MemberNo, MemberName })
  //     );
  //     setSuretyDetails(extractedDetails);
  //     hideLoader();
  //   }
  //   hideLoader();
  // };
  return (
    <div className="my-card">
      <span className="route-title-card mb-3">Surety Details</span>
      {/* Table is here */}
      <Table striped bordered hover className="mt-3">
        <thead>
          <tr className="text-dark">
            <th>Member No</th>
            <th>Member Name</th>
          </tr>
        </thead>
        <tbody>
          {suretyDetails?.length === 0 ? (
            <tr>
              <td colSpan={2} className="text-center">
                Sorry, no matching records found
              </td>
            </tr>
          ) : (
            suretyDetails?.map((detail, index) => (
              <tr key={index}>
                <td>{detail.MemberNo}</td>
                <td>{detail.MemberName}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <div className="text-center">
        {suretyDetails?.length > 0 && (
          <div className="text-center">
            <ButtonComponent
              className="text-center btn-submit"
              icon={"fas fa-eye"}
              value={"View Details"}
              onClick={() => {
                navigate("/SuretyMemberView");
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SuretyDetails;
